import React from 'react';
import PropTypes from 'prop-types';

import EmptyState from './empty_state';
import List from './list';

const ContactSelectMenu = (props) => {
  if (props.selectProps.inputValue && props.options.length) {
    return <List {...props} />;
  }

  let description;
  if (props.isLoading) {
    description = `Searching...`;
  } else if (props.selectProps.inputValue) {
    description = `No ${props.selectProps.contactTypeLabelPlural} found`;
  } else {
    description = 'Find an existing contact by typing their name or email';
  }

  return <EmptyState {...props} description={description} />;
};

ContactSelectMenu.propTypes = {
  isLoading: PropTypes.bool,
  options: PropTypes.array.isRequired,
  selectProps: PropTypes.shape({
    contactTypeLabelPlural: PropTypes.string.isRequired,
    inputValue: PropTypes.string
  })
};

export default ContactSelectMenu;
